import type { AgentMessageFragment, AgentMessageFragmentAction } from "@/hooks/use-stream-conversation";
import type { FC } from "react";
import { Button } from "@/components/flexkit/Button";
import { IconError } from "@/assets/icons/geist/IconError";
import { IconSpinner } from "@/assets/icons/geist/IconSpinner";
import { IconCode } from "@/assets/icons/geist/IconCode";
import { cn } from "@/components/podkit/lib/cn";

export const FragmentAction: FC<{
    action: AgentMessageFragmentAction;
    onClick: (message: AgentMessageFragment) => void;
}> = ({ action, onClick }) => {
    return (
        <div
            className={cn("flex items-center gap-2 duration-700 animate-in fade-in", {
                // If the action is completed we want to show it instantly rather than fade it in.
                //
                // This ensures that we only fade in the action when it's being streamed in the first time,
                // and not if you're viewing the page later.
                "opacity-1 transition-none duration-0": action.state === "completed",
            })}
        >
            <div className="contents">
                {action.state === "completed" && (
                    <IconCode size="sm" className="size-4 shrink-0 text-content-secondary" />
                )}
                {action.state === "failed" && <IconError size="base" className="size-4 shrink-0 text-content-red" />}
                {action.state === "running" && (
                    <IconSpinner size="base" className="size-4 shrink-0 animate-spin text-content-orange" />
                )}
            </div>
            <Button variant="text" size="md" className="p-0 font-normal" onClick={() => onClick(action)}>
                {action.intentDescription}
            </Button>
        </div>
    );
};
